import { createContext, useRef, type MutableRefObject, type ReactNode } from 'react';
import type { CanvasTexture } from 'three';

export interface LabDevTextures {
  artwork: CanvasTexture
  effects?: CanvasTexture
}

// Mutable pixels and texture references stay outside Redux and React updates.
export const LabDevTexturesContext = createContext<MutableRefObject<LabDevTextures | null> | null>(null);

function DevelopmentTextureProvider(props: { children: ReactNode }) {
  const textures = useRef<LabDevTextures | null>(null);
  return <LabDevTexturesContext.Provider value={textures}>
    {props.children}
  </LabDevTexturesContext.Provider>;
}

export default function LabDevTexturesProvider(props: { children: ReactNode }) {
  return process.env.NODE_ENV === 'development'
    ? <DevelopmentTextureProvider>{props.children}</DevelopmentTextureProvider>
    : <>{props.children}</>;
}
